import p5Types from "p5";

import Network from "../neat/network";
import Specie from "../neat/specie";

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
};

export function drawRect(rect: Rect, color: p5Types.Color, p5: p5Types) {
  p5.stroke(0, 0, 0, 0);
  p5.fill(color);
  p5.rect(rect.x, rect.y, rect.width, rect.height);
}

export interface GameProps<T> {
  options: T;
  onInit: () => void;
  onEachGeneration: (pool: Network[], species: Specie[]) => void;
}
